import React from 'react';
import './ImageSingle.module.scss';

type Props = {
  item: any;
};

export default function ImageSingle({ item }: Props) {
  // console.log(item, 'item');
  return (
    <div>
      <div styleName="image">
        {item.attributes.link ? (
          <a href={item.attributes.link}>
            <img alt="content" src={`/storage/${item.attributes.image}`} />
          </a>
        ) : (
          <img alt="content" src={`/storage/${item.attributes.image}`} />
        )}
      </div>
    </div>
  );
}
